import React from 'react'
import Loadable from 'react-loadable'

// Routes that render the `Chrome` should use `RouteLoader`, other routes may use `FullPageLoader`
import RouteLoader from '#src/components/RouteLoader'
import { FullPageLoader } from '@deal/components'

export const About = Loadable({
  loader: () => import(/* webpackChunkName: "about" */ '#src/routes/about'),
  loading: () => <RouteLoader />
})
export const Account = Loadable({
  loader: () => import(/* webpackChunkName: "account" */ '#src/routes/account'),
  loading: () => <RouteLoader />
})
export const Apply = Loadable({
  loader: () => import(/* webpackChunkName: "apply" */ '#src/routes/apply'),
  loading: () => <RouteLoader />
})
export const Auth = Loadable({
  loader: () => import(/* webpackChunkName: "auth" */ '#src/routes/auth'),
  loading: () => <RouteLoader />
})
export const Brands = Loadable({
  loader: () => import(/* webpackChunkName: "brands" */ '#src/routes/brands'),
  loading: () => <RouteLoader />
})
export const Careers = Loadable({
  loader: () => import(/* webpackChunkName: "careers" */ '#src/routes/careers'),
  loading: () => <RouteLoader />
})
export const ChartersRedirect = Loadable({
  loader: () => import(/* webpackChunkName: "charters-redirect" */ '#src/routes/charters'),
  loading: () => <RouteLoader />
})
export const Categories = Loadable({
  loader: () => import(/* webpackChunkName: "categories" */ '#src/routes/categories'),
  loading: () => <RouteLoader />
})
export const Curations = Loadable({
  loader: () => import(/* webpackChunkName: "curations" */ '#src/routes/curations'),
  loading: () => <RouteLoader />
})
export const Departments = Loadable({
  loader: () => import(/* webpackChunkName: "departments" */ '#src/routes/departments'),
  loading: () => <RouteLoader />
})
export const Experiences = Loadable({
  loader: () => import(/* webpackChunkName: "experiences" */ '#src/routes/experiences'),
  loading: () => <RouteLoader />
})
export const Experts = Loadable({
  loader: () => import(/* webpackChunkName: "expert" */ '#src/routes/experts'),
  loading: () => <RouteLoader />
})
export const FAQ = Loadable({
  loader: () => import(/* webpackChunkName: "faq2" */ '#src/routes/faq'),
  loading: () => <RouteLoader />
})
export const Feedback = Loadable({
  loader: () => import(/* webpackChunkName: "feedback" */ '#src/routes/feedback'),
  loading: () => <RouteLoader />
})
export const Favorites = Loadable({
  loader: () => import(/* webpackChunkName: "favorites" */ '#src/routes/favorites'),
  loading: () => <RouteLoader />
})
export const Home = Loadable({
  loader: () => import(/* webpackChunkName: "home" */ '#src/routes/home'),
  loading: () => <RouteLoader />
})
export const HowItWorks = Loadable({
  loader: () => import(/* webpackChunkName: "howItWorks" */ '#src/routes/how-it-works'),
  loading: () => <RouteLoader />
})
export const Inbox = Loadable({
  loader: () => import(/* webpackChunkName: "inbox" */ '#src/routes/inbox'),
  loading: () => <RouteLoader />
})
export const Itinerary = Loadable({
  loader: () => import(/* webpackChunkName: "itinerary" */ '#src/routes/itinerary'),
  loading: () => <RouteLoader />
})
export const Landing = Loadable({
  loader: () => import(/* webpackChunkName: "landing" */ '#src/routes/landing'),
  loading: () => <FullPageLoader />
})
export const Legal = Loadable({
  loader: () => import(/* webpackChunkName: "legal" */ '#src/routes/legal'),
  loading: () => <RouteLoader />
})
export const MeetTheExperts = Loadable({
  loader: () => import(/* webpackChunkName: "meet-the-experts" */ '#src/routes/meet-the-experts'),
  loading: () => <RouteLoader />
})
export const Orders = Loadable({
  loader: () => import(/* webpackChunkName: "orders" */ '#src/routes/orders'),
  loading: () => <RouteLoader />
})
export const Products = Loadable({
  loader: () => import(/* webpackChunkName: "sellable" */ '#src/routes/products'),
  loading: () => <RouteLoader />
})
export const PushNotifications = Loadable({
  loader: () =>
    import(/* webpackChunkName: "pushNotifications" */ '#src/routes/push-notifications'),
  loading: () => <RouteLoader />
})
export const Redirects = Loadable({
  loader: () => import(/* webpackChunkName: "redirects" */ '#src/routes/redirects'),
  loading: () => <RouteLoader />
})
export const Requests = Loadable({
  loader: () => import(/* webpackChunkName: "requests" */ '#src/routes/requests'),
  loading: () => <FullPageLoader />
})
export const Returns = Loadable({
  loader: () => import(/* webpackChunkName: "returns" */ '#src/routes/returns'),
  loading: () => <RouteLoader />
})
export const Reviews = Loadable({
  loader: () => import(/* webpackChunkName: "reviews" */ '#src/routes/reviews'),
  loading: () => <RouteLoader />
})
export const Sellable = Loadable({
  loader: () => import(/* webpackChunkName: "sellable" */ '#src/routes/sellable'),
  loading: () => <RouteLoader />
})
export const Support = Loadable({
  loader: () => import(/* webpackChunkName: "support" */ '#src/routes/support'),
  loading: () => <RouteLoader />
})
export const Team = Loadable({
  loader: () => import(/* webpackChunkName: "team" */ '#src/routes/team'),
  loading: () => <RouteLoader />
})
export const Topics = Loadable({
  loader: () => import(/* webpackChunkName: "topics" */ '#src/routes/topics'),
  loading: () => <RouteLoader />
})
